
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ChartData {
  month: string;
  count: number;
  timestamp: number;
}

interface ExitDateLineChartProps {
  chartData: ChartData[];
  compact?: boolean;
}

const ExitDateLineChart = ({ chartData, compact = false }: ExitDateLineChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart 
        data={chartData} 
        margin={{ 
          top: 5, 
          right: 20, 
          left: compact ? 10 : 20, 
          bottom: compact ? 15 : 30 
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis 
          dataKey="month" 
          tick={{ fill: '#666', fontSize: compact ? 10 : 12 }}
          tickLine={{ stroke: '#ccc' }}
          axisLine={{ stroke: '#ccc' }}
        />
        <YAxis 
          allowDecimals={false}
          tick={{ fill: '#666', fontSize: compact ? 10 : 12 }}
          tickLine={{ stroke: '#ccc' }}
          axisLine={{ stroke: '#ccc' }}
          width={compact ? 20 : 30}
        />
        <Tooltip 
          formatter={(value: number) => [value, 'Exits']}
          labelFormatter={(label: string) => label}
          contentStyle={{ 
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '8px'
          }}
        />
        <Line 
          type="monotone" 
          dataKey="count" 
          name="Exits" 
          stroke="#ea384c" 
          activeDot={{ r: compact ? 6 : 8 }} 
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ExitDateLineChart;
